<template>
  <div class="clm-frm-policy">
    <span v-if="$i18n.locale=='ru'">Нажимая кнопку «<slot></slot>», вы подтверждаете своё согласие на <a href="#">обработку персональных данных</a></span>
    <span v-else>Батырманы басу арқылы «<slot></slot>», <a href="#">деректерді өңдеуге келісіміңізді растайсыз</a></span>
  </div>
</template>

<script>
export default {
  name: "a-agreement",
}
</script>
